// src/theme/themeMap.js
export const themeMap = {
  // Backgrounds
  "bg-black": "jz-bg-dark",
  "bg-[#050505]": "jz-bg",
  "bg-[#0a0a0a]": "jz-surface",
  "bg-black/95": "jz-bg-glass-heavy",
  "bg-black/70": "jz-bg-glass",
  "bg-black/40": "jz-bg-glass-light",
  "bg-white/5": "jz-surface-faint",
  "bg-[#e60000]": "jz-primary",
  "bg-[#e60000]/10": "jz-primary-muted",
  "bg-[#e60000]/5": "jz-primary-faint",
  "bg-white": "jz-bg-inverse",

  // Gradients
  "from-[#1a0000]": "jz-from-primary-dark",
  "to-[#0a0000]": "jz-to-surface",
  "from-black/70": "jz-from-glass",
  "via-black/70": "jz-via-glass",
  "to-[#050505]": "jz-to-bg",

  // Text Colors
  "text-white": "jz-text",
  "text-neutral-100": "jz-text",
  "text-neutral-200": "jz-text-light",
  "text-neutral-300": "jz-text-light",
  "text-neutral-400": "jz-text-muted",
  "text-neutral-500": "jz-text-faint",
  "text-neutral-600": "jz-text-faintest",
  "text-[#e60000]": "jz-text-primary",
  "text-black": "jz-text-inverse",

  // Border Colors
  "border-white/10": "jz-border",
  "border-white/15": "jz-border-medium",
  "border-white/25": "jz-border-strong",
  "border-white/30": "jz-border-stronger",
  "border-[#e60000]": "jz-border-primary",
  "border-[#e60000]/40": "jz-border-primary-faint",
  "border-[#e60000]/50": "jz-border-primary-muted",
  "border-[#e60000]/60": "jz-border-primary-muted",

  // Safe Hover Names (No colons)
  "hover:bg-[#111]": "jz-hover-surface",
  "hover:bg-[#ff1a1a]": "jz-hover-primary",
  "hover:bg-neutral-200": "jz-hover-bg-inverse",
  "hover:bg-[#e60000]/10": "jz-hover-primary-muted",
  "hover:text-white": "jz-hover-text",
  "hover:text-[#e60000]": "jz-hover-text-primary",
  "hover:border-white": "jz-hover-border",
  "hover:border-[#e60000]/60": "jz-hover-border-primary",

  // Focus & Selection
  "focus:border-[#e60000]": "jz-focus-border-primary",
  "selection:bg-[#e60000]": "jz-selection-bg",
  "selection:text-white": "jz-selection-text",

  // Shadcn
  "border-input": "jz-border-input",
  "bg-popover": "jz-bg-popover",
  "text-popover-foreground": "jz-text-popover",
  "text-muted-foreground": "jz-text-muted",
  "bg-accent": "jz-bg-accent",
  "text-accent-foreground": "jz-text-accent",
  "focus-visible:ring-ring": "jz-focus-ring",
  "focus:bg-accent": "jz-focus-bg-accent",
  "focus:text-accent-foreground": "jz-focus-text-accent",
  "bg-muted": "jz-bg-muted",
};